import {
  ColorIcon,
  colors,
  EventPathType,
  HStack,
  useConfirmDialog,
  VLine,
  VStack,
} from "goi_common";
import { useGetObituary } from "../../BugoCreateContainer/hooks/useGetObituary";
import { BugoSection } from "../../BugoCreateContainer/components/BugoSection";

const SANGJU_PER_ROW_WITH_PHONE = 3;
const SANGJU_PER_ROW_WITHOUT_PHONE = 4;

interface BugoDetailSangjuSectionProps {
  readOnly?: boolean;
  isVisitorType: boolean;
  path: EventPathType;
}

export const BugoDetailSangjuSection = ({
  readOnly,
  isVisitorType,
  path,
}: BugoDetailSangjuSectionProps) => {
  const { data } = useGetObituary();

  const sangjuGroup = data?.sangjus?.reduce((acc, sangju) => {
    if (!acc[sangju.relation]) {
      acc[sangju.relation] = [];
    }
    acc[sangju.relation].push(sangju);
    return acc;
  }, {} as Record<string, typeof data.sangjus>);

  const { openConfirmDialog } = useConfirmDialog();

  return (
    <BugoSection title="상주">
      {sangjuGroup && (
        <VStack gap="20px">
          {Object.entries(sangjuGroup).map(([relationKey, value]) => {
            const onClickHasPhoneSangju = ({
              name,
              phone,
            }: {
              name: string;
              phone: string;
            }) => {
              openConfirmDialog({
                content: (
                  <span>
                    <b>{name}</b>님에게
                    <br />
                    전화를 거시겠어요?
                  </span>
                ),
                cancelButtonText: "취소하기",
                confirmButtonText: "전화걸기",
                onClickConfirmButton: () => {
                  window.open(`tel:${phone}`);
                },
              });
            };

            const hasAnyPhone = value.some((sangju) => sangju.phone);
            const perRow = hasAnyPhone
              ? SANGJU_PER_ROW_WITH_PHONE
              : SANGJU_PER_ROW_WITHOUT_PHONE;

            const chunks: (typeof value)[] = [];
            for (let i = 0; i < value.length; i += perRow) {
              chunks.push(value.slice(i, i + perRow));
            }

            return (
              <HStack key={relationKey} alignItems="flex-start">
                <div
                  className="body_16_m gray600"
                  css={{
                    maxWidth: "60px",
                    width: "60px",
                    marginRight: "20px",
                    flexShrink: 0,
                  }}
                >
                  {relationKey}
                </div>

                <VStack gap="8px" css={{ flex: 1, minWidth: 0 }}>
                  {chunks.map((chunk, chunkIndex) => (
                    <HStack key={chunkIndex} alignItems="center">
                      {chunk.map((sangju, index) => (
                        <HStack
                          key={sangju.key}
                          alignItems="center"
                          css={{
                            cursor: sangju.phone ? "pointer" : "default",
                          }}
                          onClick={() => {
                            if (sangju.name && sangju.phone) {
                              onClickHasPhoneSangju({
                                name: sangju.name,
                                phone: sangju.phone,
                              });
                            }
                          }}
                        >
                          {index !== 0 && (
                            <VLine
                              css={{
                                maxHeight: "12px",
                                margin: "0px 10px",
                              }}
                              color={colors.gray300}
                            />
                          )}
                          <HStack gap="4px" alignItems="center">
                            <div className="body_16_m">{sangju.name}</div>
                            {sangju.phone && (
                              <ColorIcon
                                name="icon-call-mono"
                                size="14px"
                                color={colors.warmGray650}
                              />
                            )}
                          </HStack>
                        </HStack>
                      ))}
                    </HStack>
                  ))}
                </VStack>
              </HStack>
            );
          })}
        </VStack>
      )}
    </BugoSection>
  );
};
